'use client';
// biome-ignore lint/correctness/noUndeclaredDependencies: peer dependency provided by host app
import { Card } from '@gartner-digital-markets/nimbus-v3-ui';
import type { ReactNode } from 'react';
import { cn } from '../ui/utils';

/**
 * Card background options for bx-forms.
 * - 'default': White background (bg-nimbus-background)
 * - 'brand': Brand-specific secondary color (bg-nimbus-secondary)
 *   - Capterra: light blue (#ebf2ff)
 *   - Software Advice: light purple (#EFE8FA)
 *   - GetApp: light teal (#ecf9fa)
 */
export type CardBackground = 'default' | 'brand';

const BACKGROUND_STYLES: Record<CardBackground, string> = {
  default: 'bg-nimbus-background',
  brand: 'bg-nimbus-secondary',
};

interface FormCardProps {
  children: ReactNode;
  className?: string;
  style?: React.CSSProperties;
  cardBackground?: CardBackground;
  cardless?: boolean;
}

export const FormCard = ({
  children,
  className,
  style,
  cardBackground = 'default',
  cardless = false,
}: FormCardProps) => {
  if (cardless) {
    return (
      <div
        className={cn('w-full', className)}
        style={style}
        data-testid="bx-forms-inline-form"
      >
        {children}
      </div>
    );
  }

  return (
    <Card
      padding="lg"
      className={cn(
        'w-full text-nimbus-foreground shadow-nimbus-md',
        BACKGROUND_STYLES[cardBackground],
        className
      )}
      style={style}
      data-testid="bx-forms-inline-form"
    >
      {children}
    </Card>
  );
};
